import HomeRoute from './HomeRoute';

export default HomeRoute;
